var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 31,
    viewBox: "0 0 47 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5411 29.9858C8.84335 29.9858 6.25607 28.9607 4.34845 27.136C2.44083 25.3113 1.36914 22.8365 1.36914 20.2561C1.36914 17.6756 2.44083 15.2008 4.34845 13.3761C6.25607 11.5514 8.84335 10.5263 11.5411 10.5263C12.1783 7.6878 14.0422 5.19332 16.7229 3.59166C19.4036 1.99 22.6815 1.41235 25.8354 1.98579C28.9894 2.55923 31.761 4.23679 33.5406 6.64942C35.3202 9.06205 35.9621 12.0121 35.3249 14.8507H37.4871C39.4941 14.8507 41.419 15.648 42.8382 17.0671C44.2574 18.4863 45.0546 20.4112 45.0546 22.4182C45.0546 24.4253 44.2574 26.3501 42.8382 27.7693C41.419 29.1885 39.4941 29.9858 37.4871 29.9858H11.5411Z",
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.b403669d5c9676c4c2b8eaa067de4833.svg";
export { ForwardRef as ReactComponent };